import { useState, useCallback, useEffect } from "react";
import { useParams } from "react-router-dom";
import AgreementShowInfo from "./AgreementShowInfo";
import { getAgreement } from "../../services/agreementServices";
import Paper from "@mui/material/Paper";
import ReportShowInfo from "./ReportShowInfo";
import { getReport } from "../../services/agreementServices";

const PublicAgreementShow = ({ id }) => {
  const agreementId = id;
  const [agreement, setAgreement] = useState(null);
  const [report, setReport] = useState(null);
  const [notAllowed, setNotAllowed] = useState(false);
  const [signers, setSigners] = useState([]);

  const agreementData = useCallback(async () => {
    try {
      const response = await getAgreement(
        `/api/v1/agreements/public/${agreementId}`
      );
      

      const data = response.data.data;

      const status = data.status?.toLowerCase().trim();
      const allowedStatuses = ["signed", "expired", "next_to_expired", "finished"];
      


      if (!allowedStatuses.includes(status)) {
        setNotAllowed(true);
        return;
      }


      setAgreement(data);
      setSigners(data.signers);
      
      const responseReport = await getReport(agreementId);
      setReport(responseReport.data);
      
    } catch (err) {
      setNotAllowed(true);
      console.error("Error al obtener el convenio:", err);
    }
  }, [agreementId]);

  useEffect(() => {
    if (agreementId) {
      agreementData();
    }
  }, [agreementId, agreementData]);

  if (notAllowed) {
    return <p>Este convenio no está disponible públicamente.</p>;
  }

  if (!agreement) {
    return <p>Cargando...</p>;
  }

  return (
    <Paper elevation={2} sx={{ padding: 5 }}>
      <AgreementShowInfo
        agreement={agreement}
        signers={signers}
        hideInfo={true}
      />
      <ReportShowInfo report={report} />
    </Paper>
  );
};

export default PublicAgreementShow;
